import React from 'react';
import { dispatch } from 'nike-re-framejs';
import { fireGAEvent } from '@/analytics';

import DeleteIcon from '@/icons/DeleteIcon';
import ArrowLeftIcon from '@/icons/ArrowLeftIcon';
import clsx from 'clsx';
import LeftIcon from '@/icons/LeftIcon';
import { SvgIcon } from 'nike-ui/src/icons/SvgIcon';
import { COMMUNITY_LOBBY } from '@/routing/routes';
//TODO: Toto nema nic s headrom je potrebne to nejak logicky porehadzovat, resp. upravit pouzitie
export const ArrowButton = () => (
    <div className="back-arrow pointer">
        <ArrowLeftIcon width={20} height={20} opacity={1} fill={'#fff'} />
    </div>
);

export const LeftIconButton = () => (
    <div className="pointer">
        <LeftIcon width={20} height={20} opacity={1} fill={'#fff'} />
    </div>
);

export const CrossButton = () => (
    <div className="close-icon pointer">
        <DeleteIcon height={14} width={14} />
    </div>
);

export const BackButton = ({ button, onClick, trackData, otherClass, className = 'btn-go-back', isBetbook }) => {
    const handleClick = e => {
        if (typeof onClick === 'function') {
            onClick(e);
            return;
        }
        e.preventDefault();
        if (trackData) {
            fireGAEvent(trackData.category, trackData.action, trackData.label);
        }
        dispatch(isBetbook ? ['history_back', COMMUNITY_LOBBY] : ['history_back']);
    };
    return (
        <div className="header-flex-back pointer">
            <div className={clsx(className, otherClass)} data-atid="main-menu-go-back" onClick={handleClick}>
                {button ? button : <SvgIcon imgId="live-back" sizeX="16" sizeY="12" className="mr-5 c-white" />}
            </div>
        </div>
    );
};
